export const jobTypeCodes = {
  JobOrder: 'JO',
  SalesOrder: 'SO',
  PriceQuote: 'PQ',
}
